import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Webhook, WebhookCreate, WebhookUpdate } from '../../../shared/interfaces/webhook.interfaces';

export const WebhookActions = createActionGroup({
  source: 'Webhook',
  events: {
    'Load Webhooks': emptyProps(),
    'Load Webhooks Success': props<{ data: Webhook[] }>(),

    'Create Webhook': props<{ payload: WebhookCreate }>(),
    'Create Webhook Success': props<{ data: any }>(),

    'Update Webhook': props<{ payload: WebhookUpdate }>(),
    'Update Webhook Success': props<{ data: any }>(),

    'Delete Webhook': props<{ id: number }>(),
    'Delete Webhook Success': props<{ data: any }>(),

    'Test Webhook': props<{ id: number }>(),
    'Test Webhook Success': props<{ data: any }>(),

    'Reset Test': emptyProps(),

    'Unset Webhook Store': emptyProps(),
  }
});
